export default __webpack_public_path__ + "static/smart-model-preview-btn-small-8dd9ed8756d5324aa5f378e0fccb1557.png";